import FluxList from '@/components/flux/FluxList'

export default [
  {
    path: '/flux',
    name: 'FluxList',
    component: FluxList,
    meta: {
      parentName: 'Home',
      requiresAuth: true,
      needProfile: ['admin'],
      maxHeight: true
    }
  }
]



// WEBPACK FOOTER //
// ./src/router/fluxRouter.js